module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-ip-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.reserveIpProcessing
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/reserve_ip')) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "5px"
    }
  })])]), _vm._v(" "), [_c('h4', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/ip4_count')))]), _vm._v(" "), (_vm.Status === 'active') ? _c('div', {
    staticClass: "ip-count-info"
  }, [_c('div', {
    staticClass: "ip-count-info-ip"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.countIP4),
      expression: "countIP4"
    }],
    staticClass: "ip-count-info-ip-item"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.costIP4),
      expression: "costIP4"
    }],
    staticClass: "ip-count-info-ip-item"
  })])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w5-ip-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-ip-table-th-0"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/ippool')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/host')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-2"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/gateway')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-3"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/netmask')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-4"
  })])]), _vm._v(" "), (_vm.ip4 && _vm.ip4['rows'] && _vm.ip4['rows'].length) ? _c('tbody', _vm._l((_vm.ip4['rows']), function(ip4, idx) {
    return _c('tr', {
      key: 'ip4-' + ip4['id'],
      class: {
        'w5-list-selected-row': ip4['selected'] === true
      }
    }, [_c('td', {
      class: {
        'color-red': ip4['status'] !== 'active' || ip4['status_text']
      },
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/ippool')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['address']))])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/host')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_c('span', {
      staticClass: "w5-modal-link",
      on: {
        "click": function($event) {
          return _vm.changeHost(ip4, '4')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(ip4['host'] ? ip4['host'] : 'main/create ipptrpool/ipptrpool')))])])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/gateway')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['gateway']))])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/netmask')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['netmask']))])]), _vm._v(" "), _c('td', [(_vm.Status === 'active' && !ip4['status_text'] && ip4['status'] === 'active') ? _c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.configOpersIp4,
        "row": ip4,
        "index": idx,
        "crud": "service"
      },
      on: {
        "action": _vm.actionOperButton
      }
    }) : _vm._e()], 1)])
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": require("../../assets/img/puzzle.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ip4['max'] && _vm.ip4['max'] > 0),
      expression: "ip4['max'] && ip4['max'] > 0"
    }],
    staticClass: "btn btn-submit margin-top-15 font-weight-300",
    attrs: {
      "disabled": !_vm.Access || !_vm.ipInfo || _vm.activeProcess ? 'disabled' : false
    },
    on: {
      "click": function($event) {
        return _vm.buyIP('4')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order service/ip4_count')))])], _vm._v(" "), [_c('div', {
    staticStyle: {
      "height": "60px"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/ip6_count')))]), _vm._v(" "), (_vm.Status === 'active') ? _c('div', {
    staticClass: "ip-count-info"
  }, [_c('div', {
    staticClass: "ip-count-info-ip"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.countIP6),
      expression: "countIP6"
    }],
    staticClass: "ip-count-info-ip-item"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.costIP6),
      expression: "costIP6"
    }],
    staticClass: "ip-count-info-ip-item"
  })])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w5-ip-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-ip-table-th-0"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/ippool')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/host')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-2"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/gateway')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-3"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/netmask')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-4"
  })])]), _vm._v(" "), (_vm.ip6 && _vm.ip6['rows'] && _vm.ip6['rows'].length) ? _c('tbody', _vm._l((_vm.ip6['rows']), function(ip6, idx) {
    return _c('tr', {
      key: 'ip6-' + ip6['id'],
      class: {
        'w5-list-selected-row': ip6['selected'] === true
      }
    }, [_c('td', {
      class: {
        'color-red': ip6['status'] !== 'active' || ip6['status_text']
      },
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/ippool')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['address']))])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/host')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_c('span', {
      staticClass: "w5-modal-link",
      on: {
        "click": function($event) {
          return _vm.changeHost(ip6, '6')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(ip6['host'] ? ip6['host'] : 'main/create ipptrpool/ipptrpool')))])])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/gateway')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['gateway']))])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/netmask')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['netmask']))])]), _vm._v(" "), _c('td', [(_vm.Status === 'active' && !ip6['status_text'] && ip6['status'] === 'active') ? _c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.configOpersIp6,
        "row": ip6,
        "index": idx,
        "crud": "service"
      },
      on: {
        "action": _vm.actionOperButton
      }
    }) : _vm._e()], 1)])
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": require("../../assets/img/puzzle.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ip6['max'] && _vm.ip6['max'] > 0),
      expression: "ip6['max'] && ip6['max'] > 0"
    }],
    staticClass: "btn btn-submit margin-top-15 font-weight-300",
    attrs: {
      "disabled": !_vm.Access || !_vm.ipInfo || _vm.activeProcess ? 'disabled' : false
    },
    on: {
      "click": function($event) {
        return _vm.buyIP('6')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order service/ip6_count')))])], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.deleteModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteBegin
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showHostModal) ? _c('div', {
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideHostModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: _vm.hostModalContainerClass,
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.hostModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideHostModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding-top": "0"
    }
  }, [(_vm.selectedIpId) ? _c('Table', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "crud": "ipptrpool",
      "crud-search-model": "IpPtrPoolSearch",
      "access": _vm.Access,
      "url-list": _vm.tableUrlList,
      "url-create": _vm.tableUrlCreate,
      "url-update": _vm.tableUrlUpdate,
      "columns": _vm.tableColumns,
      "inner-forms": true,
      "in-modal": true,
      "create-button-title": "ipptrpool/create_title",
      "id-columns": "ptr_id"
    },
    on: {
      "error": _vm.getError,
      "title": function (value) { return _vm.hostModalTitle = value; },
      "refresh": _vm.requestData,
      "containerClass": function (value) { return _vm.hostModalContainerClass = value; },
      "currentMode": function (value) { return _vm.hostModalCurrentMode = value; }
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBuyModal),
      expression: "showBuyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBuyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ippool/buy_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBuyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.reserveIpField,
      "removeRightPadding": true,
      "listBlockToOut": 1,
      "fieldInModal": true
    },
    model: {
      value: (_vm.reserveIpFieldValue),
      callback: function($$v) {
        _vm.reserveIpFieldValue = $$v
      },
      expression: "reserveIpFieldValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.buyBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order ' + (_vm.buyType === '4' ? 'service/ip4_count' : 'service/ip6_count'))))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalText)),
      expression: "localeFtc(confirmModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.confirmModalDangerButton
    },
    attrs: {
      "disabled": _vm.confirmModalTimer && _vm.confirmModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmStart
    }
  }, [_vm._v(_vm._s(_vm.modalConfirmButtonTitle) + "\n\t\t\t\t\t\t")])])])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3164cf9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vds/ip.vue
// module id = 576
// module chunks = 0